import { Typography } from "@platform/design-system";

interface LabeledValueProps {
  label: string;
  value: React.ReactNode;
}

export const LabeledValue = ({
  label,
  value,
}: LabeledValueProps): React.JSX.Element => (
  <Typography variant="body-medium" color="textSecondary">
    {label}:{" "}
    <Typography variant="body-medium" component="span">
      {value}
    </Typography>
  </Typography>
);
